export const DEFAULT_LIBRARY_ID = "default";
export const SILENCE_LABEL = "silence";
export function qualifiedLabel(libraryId, phonemeId) {
    if (phonemeId === SILENCE_LABEL)
        return SILENCE_LABEL;
    if (libraryId === DEFAULT_LIBRARY_ID)
        return phonemeId;
    return `${libraryId}:${phonemeId}`;
}
export function unqualifyLabel(libraryId, label) {
    if (label === SILENCE_LABEL)
        return SILENCE_LABEL;
    if (libraryId === DEFAULT_LIBRARY_ID)
        return label;
    const prefix = `${libraryId}:`;
    return label.startsWith(prefix) ? label.slice(prefix.length) : label;
}
